export default __webpack_public_path__ + "static/media/colizeum_logo.0c938575.png";